<template>
  <component
    :is="tag"
    :type="tag === 'button' ? 'button' : undefined"
   
    :class="isOpen ? expandedClasses : collapsedClasses"
  >
    <slot v-if="isOpen" />
    <slot
      v-else
      name="collapsed"
    />
  </component>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  tag?: 'button' | 'div'
  testId?: string
  isOpen: boolean
  isFocused: boolean
  isDimmed?: boolean
  showDivider?: boolean
  showLeftDivider?: boolean
  expandedClass?: string | (string | Record<string, boolean>)[] | Record<string, boolean>
  collapsedClass?: string | (string | Record<string, boolean>)[] | Record<string, boolean>
}>(), {
  tag: 'button',
})

const expandedClasses = computed(() => [
  'relative rounded-full h-full py-3 cursor-pointer transition-colors min-w-0',
  props.expandedClass,
  {
    'bg-white': props.isFocused,
    'hover:bg-gray-200/60': !props.isFocused,
    'after:content-[\'\'] after:block after:w-[1px] after:h-3/5 after:absolute after:top-1/5 after:bg-gray-200 after:right-0 after:z-10': props.showDivider,
    'after:opacity-50': props.isDimmed,
  },
])

const collapsedClasses = computed(() => [
  'relative flex items-center gap-2 font-medium py-3 cursor-pointer',
  props.collapsedClass,
  {
    'before:content-[\'\'] before:block before:w-px before:h-[calc(100%-1rem)] before:bg-gray-200 before:absolute before:left-0 before:top-2': props.showLeftDivider,
  },
])
</script>
